import { Paper } from '@mui/material';
import { DataGrid, GridColDef, GridSlotsComponent } from '@mui/x-data-grid';
import { ReactNode } from 'react';
import { TFunction, useTranslation } from 'react-i18next';
import {
	WinLoseDataRow,
	WinLosePlayerDataRow,
	BetData,
	TxTransactionHistoryData,
	TransactionDataRow,
	RequisitionDataRow,
	Account,
} from '../models';
import { WRAP_CELL_CLASS } from './ManagementTableColumns';
import { winloseColumns } from './ReportTableColumns';

type Props = {
	list:
		| WinLoseDataRow[]
		| WinLosePlayerDataRow[]
		| BetData[]
		| TxTransactionHistoryData[]
		| TransactionDataRow[]
		| RequisitionDataRow[]
		| Account[];
	slots?: Partial<GridSlotsComponent>;
	columns?: ((t: TFunction, component?: (value: string) => ReactNode) => GridColDef)[];
	initialState?: {};
};

export function Table({ list, slots, columns = winloseColumns, initialState = {} }: Props) {
	const { t } = useTranslation();

	return (
		<Paper className="p-2">
			<DataGrid
				rows={list.map((row, index) => ({ id: index, ...row }))}
				columns={columns.map((col) => col(t))}
				hideFooter
				disableRowSelectionOnClick
				disableColumnMenu
				slots={slots}
				className="border-none"
				sx={{
					// A wrapping cell loses the line-height trick the grid uses to centre single-line
					// text, so centre it explicitly instead.
					[`& .${WRAP_CELL_CLASS}`]: {
						display: 'flex',
						alignItems: 'center',
						whiteSpace: 'normal',
						lineHeight: 1.35,
					},
				}}
				initialState={initialState}
			/>
		</Paper>
	);
}
